import { metricToTitleMap, secondaryDimensionToTitleMap } from './constants';
import type { PositionedItem } from './types/item';

export const getChartTitle = (item: PositionedItem): string => {
  const { defaultMetricOptions, secondaryDimension } = item.plot ?? {};
  const firstMetric = defaultMetricOptions?.[0];
  if (!firstMetric) return '';

  const metricLabel =
    metricToTitleMap[firstMetric as keyof typeof metricToTitleMap] ??
    (firstMetric.startsWith('sq:') ? 'Custom variable' : firstMetric);

  if (secondaryDimension) {
    return `${metricLabel} by ${secondaryDimensionToTitleMap[secondaryDimension]}`;
  }
  return metricLabel;
};
